var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.03,53.21c-.94,0-1.85-.36-2.57-1.04L49.16,10.95,6.77,51.59c-1.1,1.06-2.67,1.34-4.08.74-1.4-.6-2.27-1.91-2.27-3.42,0-1.01.42-1.98,1.15-2.68L46.56,3.09c1.45-1.39,3.74-1.4,5.2,0l45.88,43.68h0c.73.7,1.16,1.68,1.16,2.69,0,1.54-.87,2.85-2.26,3.45-.49.21-1,.31-1.51.31ZM49.16,8.57c.25,0,.5.09.69.28l43.98,41.87c.53.5,1.24.63,1.91.34.66-.28,1.05-.87,1.05-1.58,0-.49-.19-.94-.53-1.27L50.38,4.53c-.68-.65-1.75-.65-2.44,0L2.94,47.67c-.34.32-.53.77-.53,1.24,0,.71.39,1.3,1.06,1.58.67.29,1.39.16,1.91-.35L48.47,8.85c.19-.19.44-.28.69-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.67,97.17H14.18c-.55,0-1-.45-1-1v-52.69c0-.55.45-1,1-1s1,.45,1,1v51.69h67.49v-52.29c0-.55.45-1,1-1s1,.45,1,1v53.29c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.29,97.17h-20.94c-.55,0-1-.45-1-1v-42.98c0-.55.45-1,1-1h20.94c.55,0,1,.45,1,1v42.98c0,.55-.45,1-1,1ZM25.35,95.17h18.94v-40.98h-18.94v40.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.67,35.84c-.55,0-1-.45-1-1V8.48h-10.19v14.75c0,.55-.45,1-1,1s-1-.45-1-1V7.48c0-.55.45-1,1-1h12.19c.55,0,1,.45,1,1v27.36c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.86,77.51h-20.94c-.55,0-1-.45-1-1v-23.33c0-.55.45-1,1-1h20.94c.55,0,1,.45,1,1v23.33c0,.55-.45,1-1,1ZM54.92,75.51h18.94v-21.33h-18.94v21.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.86,65.85h-20.94c-.55,0-1-.45-1-1s.45-1,1-1h20.94c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.39,77.51c-.55,0-1-.45-1-1v-23.33c0-.55.45-1,1-1s1,.45,1,1v23.33c0,.55-.45,1-1,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.b53053630fd76f624c0939bf3fd5a8bc.svg";
export { ForwardRef as ReactComponent };